export enum EventLogNames {
  completeLaterButtonClick = 'completeLaterButtonClick'
}
